export default {
  text: 'Use your remaining points ({0} points)'
}